module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kansai-1-29deea19077d0ffdffacca70b1556972.jpg";